var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        size: "xl",
        top: "5vh",
        "use-panel": false,
        "show-confirm": false,
        "cancel-text": "Đóng",
      },
      on: { cancel: _vm.closeDialog, "before-close": _vm.closeDialog },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.closeDialog },
                    },
                    [_vm._v("Đóng")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "sk-dialog-content" }, [
        _c("div", { staticClass: "sk-panel" }, [
          _c("div", { staticClass: "sk-panel-head" }, [
            _c("div", { staticClass: "sk-panel-icon" }, [
              _c("i", { staticClass: "el-icon-time" }),
            ]),
            _c("div", { staticClass: "sk-panel-info" }, [
              _c("p", { staticClass: "sk-panel-title" }, [
                _vm._v("Lịch sử trạng thái & vòng đời nhân sự Plus"),
              ]),
              _c(
                "p",
                { staticClass: "sk-panel-subtitle" },
                [
                  _c("span", [
                    _vm._v("Họ tên: "),
                    _c("strong", { staticClass: "text-slate-800" }, [
                      _vm._v(_vm._s(_vm.employeeName)),
                    ]),
                  ]),
                  _c("span", { staticClass: "info-divider" }, [_vm._v("•")]),
                  _c("span", [
                    _vm._v("Mã NV: "),
                    _c("strong", { staticClass: "text-slate-800" }, [
                      _vm._v(_vm._s(_vm.employeeCode)),
                    ]),
                  ]),
                  _vm.employeePhone
                    ? [
                        _c("span", { staticClass: "info-divider" }, [
                          _vm._v("•"),
                        ]),
                        _c("span", [
                          _vm._v("SĐT: "),
                          _c("strong", { staticClass: "text-slate-800" }, [
                            _vm._v(_vm._s(_vm.employeePhone)),
                          ]),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "lifecycle-summary-badge" }, [
              _c("span", [
                _vm._v("Tổng cộng: "),
                _c("strong", [_vm._v(_vm._s(_vm.total))]),
                _vm._v(" bản ghi"),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "lifecycle-toolbar" }, [
            _c("div", { staticClass: "lifecycle-filter-grid" }, [
              _c(
                "div",
                { staticClass: "lifecycle-filter-item" },
                [
                  _c("label", { staticClass: "lifecycle-filter-label" }, [
                    _vm._v("Loại sự kiện"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticClass: "lifecycle-select",
                      attrs: {
                        clearable: "",
                        placeholder: "Tất cả sự kiện",
                        size: "small",
                      },
                      on: { change: _vm.filterChanged },
                      model: {
                        value: _vm.filters.eventType,
                        callback: function ($$v) {
                          _vm.$set(_vm.filters, "eventType", $$v)
                        },
                        expression: "filters.eventType",
                      },
                    },
                    _vm._l(_vm.eventTypes, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lifecycle-filter-item" },
                [
                  _c("label", { staticClass: "lifecycle-filter-label" }, [
                    _vm._v("Từ ngày"),
                  ]),
                  _c("el-date-picker", {
                    staticClass: "lifecycle-date-picker",
                    attrs: {
                      type: "date",
                      size: "small",
                      "value-format": "yyyy-MM-dd",
                      format: "dd-MM-yyyy",
                      clearable: "",
                      placeholder: "Chọn từ ngày",
                    },
                    on: { change: _vm.filterChanged },
                    model: {
                      value: _vm.filters.fromDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "fromDate", $$v)
                      },
                      expression: "filters.fromDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "lifecycle-filter-item" },
                [
                  _c("label", { staticClass: "lifecycle-filter-label" }, [
                    _vm._v("Đến ngày"),
                  ]),
                  _c("el-date-picker", {
                    staticClass: "lifecycle-date-picker",
                    attrs: {
                      type: "date",
                      size: "small",
                      "value-format": "yyyy-MM-dd",
                      format: "dd-MM-yyyy",
                      clearable: "",
                      placeholder: "Chọn đến ngày",
                    },
                    on: { change: _vm.filterChanged },
                    model: {
                      value: _vm.filters.toDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "toDate", $$v)
                      },
                      expression: "filters.toDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "lifecycle-filter-item lifecycle-filter-item--action",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        plain: "",
                        icon: "el-icon-refresh",
                      },
                      on: { click: _vm.resetFilters },
                    },
                    [_vm._v("\n              Đặt lại\n            ")]
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "lifecycle-table-wrapper sk-u-mt-12" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "sk-table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.events,
                    border: "",
                    stripe: "",
                    "max-height": "460",
                    "empty-text": "Chưa có lịch sử nhân sự",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "STT",
                      type: "index",
                      width: "50",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Ngày hiệu lực",
                      width: "130",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              { staticClass: "font-medium text-slate-800" },
                              [
                                _vm._v(
                                  _vm._s(_vm.formatDate(row.effectiveDate))
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Sự kiện", width: "165", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "small",
                                  type: _vm.tagType(row.eventType),
                                },
                              },
                              [_vm._v(_vm._s(_vm.eventLabel(row.eventType)))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Nội dung thay đổi",
                      "min-width": "320",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [_vm._v(_vm._s(_vm.description(row)))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Người thao tác",
                      width: "170",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(row.actorName || "Hệ thống")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "Nguồn", width: "125", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "info",
                                  effect: "plain",
                                },
                              },
                              [_vm._v(_vm._s(_vm.sourceLabel(row.source)))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Lúc thao tác",
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "text-slate-500" }, [
                              _vm._v(
                                _vm._s(_vm.formatDateTime(row.createdDate))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "lifecycle-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.pageNumber,
                  "page-size": _vm.maxPageItem,
                  "page-sizes": _vm.$pageListDefaultNew || [10, 20, 50, 100],
                  total: _vm.total,
                  layout: "total, sizes, prev, pager, next",
                },
                on: {
                  "size-change": _vm.sizeChanged,
                  "current-change": _vm.pageChanged,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }